<template>
  <transition mode="out-in">
    <div 
      v-if="value" 
      class="background ">
      <div class="load-wrap">
        <div class="load-wrap__inner">
          <span>L</span>
          <span>O</span>
          <span>A</span>
          <span>D</span>
          <span>I</span>
          <span>N</span>
          <span>G</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'NowLoading',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.load-wrap {
  margin: auto;
  padding: 20px 20px 20px;
  border-radius: 5px;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  &__inner{
    span{
      font-size: 16px;
      color: $grey18;
      display: inline-block;
      margin: 0 2px;
      animation: loading .7s infinite;
      &:nth-child(2) {
        animation-delay: .1s;
      }
      &:nth-child(3) {
        animation-delay: .2s;
      }
      &:nth-child(4) {
        animation-delay: .3s;
      }
      &:nth-child(5) {
        animation-delay: .4s;
      }
      &:nth-child(6) {
        animation-delay: .5s;
      }
      &:nth-child(7) {
        animation-delay: .6s;
      }
    }
  }
}
@keyframes loading {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(10px);
  }
}

.background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s;
}
.v-enter,
.v-leave-to {
  opacity: 0;
}
</style>

